import { WorkTeamsForm } from 'pages/Finance/WorkTeams/components/WorkTeamsForm';
import { RaRecord } from 'react-admin';
import { CancelButton, SaveButton } from 'shared/mui/Buttons';
import { CreateGuesserPage } from 'shared/react-admin/Pages/CreateGuesserPage/CreateGuesserPage';

import { BoxStyled } from './WorkTeamsCreate.styled';

export const WorkTeamsCreate = () => {
  return (
    <CreateGuesserPage
      listName="Рабочие группы"
      mutationOptions={{ onError: () => undefined }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
        <SaveButton key="save-button" label="Создать" />,
      ]}
      title="Создание рабочей группы"
      transform={(data: RaRecord) => {
        return {
          ...data,
          reddyChatId: data?.reddyChatId ? Number(data?.reddyChatId) : null,
        };
      }}
    >
      <BoxStyled>
        <WorkTeamsForm />
      </BoxStyled>
    </CreateGuesserPage>
  );
};
